import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiToken, baseUrl } from "../../utils/base_url";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../Button/Button";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { useMediaQuery } from "react-responsive";

const Footer = () => {
  const [footerData, setFooterData] = useState();

  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const res = await axios.get(
          `${baseUrl}/api/footers?populate=social_icons&populate=footer_links.links&populate=scheduler.CTA&populate=footer_logo`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        console.log(res?.data?.data[0]);
        setFooterData(res?.data?.data[0]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchFooterData();
  }, []);

  // console.log(footerData);
  const navigate = useNavigate();

  return (
    <div
      className="contianer-fluid p-0 m-0"
      style={{
        background: "#000",
      }}
    >
      <div
        style={{
          backgroundColor: footerData?.scheduler?.backgroundColor,
          height: _1600 ? "300px" : "321px",
        }}
      >
        <div className="container h-100 d-flex flex-column justify-content-center px-0 contwidth">
          <div className="row px-0">
            <div className="col-12 col-md-8 d-flex flex-column justify-content-center gap-0">
              <h3
                className="mb-4 text-md-start text-center mb-md-0"
                style={{
                  fontWeight: "800",
                  fontSize: _1200
                    ? "25px"
                    : _1400
                    ? "30px"
                    : _1600
                    ? "35px"
                    : "40px",
                  color: "#fff",
                }}
              >
                {footerData?.scheduler?.description}
              </h3>
            </div>
            <div className="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
              <Button
                children={footerData?.scheduler?.CTA?.text}
                onClick={() => navigate(footerData?.scheduler?.CTA?.url)}
                newButtonClassName={"rounded-3 border-0 fs20 fw500 btnres"}
                textColor={footerData?.scheduler?.CTA?.textColor}
                background={footerData?.scheduler?.CTA?.backgroundColor}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container px-0  py-5 h-100 contwidth">
        <div className="row  h-100">
          <div className="col-md-3 col-lg-5 col-12">
            <div
              style={{
                marginBottom: "2rem",
              }}
            >
              {/* logo and Social Icons */}
              <div className="d-flex items-center flex-column gap-4">
                <Link className="navbar-brand" to={"/"}>
                  <img
                    src={`${baseUrl}${footerData?.footer_logo?.url}`}
                    alt="Footer logo"
                    style={{ width: "171px", height: "26px" }}
                  />
                </Link>
                <div className="d-flex items-center gap-3">
                  {footerData?.social_icons?.map((icon, idx) => (
                    <Link to={icon?.icon_link} target={icon?.target}>
                      <div dangerouslySetInnerHTML={{ __html: icon?.icon }} />
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 col-lg-7 col-12">
            <div className="d-flex gap-5 flex-wrap align-items-start">
              {/* menus */}
              {footerData?.footer_links?.map((data, idx) => (
                <div
                  key={idx}
                  className=""
                  style={{
                    minWidth: "140px",
                    marginBottom: "2rem",
                  }}
                >
                  <div className="d-flex flex-column gap-3 ">
                    {data?.heading && (
                      <span className="fw-bold" style={{ color: " #A1A9B6" }}>
                        {data?.heading}
                      </span>
                    )}
                    {data?.links.map((info, id) => (
                      <Link
                        key={id}
                        to={`${info?.link}`}
                        className=" text-decoration-none text-white"
                      >
                        {info?.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12">
            <p
              className="text-white"
              style={{
                textAlign: "justify",
                fontWeight: "400",
                fontSize: _1700 ? "18px" : "22px",
                lineHeight: "100%",
                margin: "2rem 0rem",
              }}
            >
              {footerData?.footer_notice}
            </p>
            <span className="text-white">{footerData?.copyright}</span>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <div className="container-fluid bg-success">
        <div
          className="row"
          style={{
            backgroundColor: footerData?.scheduler?.backgroundColor,
            height: "321px",
          }}
        >
          <div className="container px-0">
            <div className="container h-100 d-flex flex-column justify-content-center px-0 contwidth">
              <div className="row px-0">
                <div className="col-12 col-md-8  d-flex flex-column justify-content-center gap-0">
                  <h3
                    className="mb-4 text-md-start text-center mb-md-0"
                    style={{
                      fontWeight: "800",
                      fontSize: _1200
                        ? "25px"
                        : _1400
                        ? "30px"
                        : _1600
                        ? "35px"
                        : "40px",
                      color: "#fff",
                    }}
                  >
                    {footerData?.scheduler?.description}
                  </h3>
                </div>
                <div className="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
                  <Button
                    children={footerData?.scheduler?.CTA?.text}
                    onClick={() => navigate(footerData?.scheduler?.CTA?.url)}
                    newButtonClassName={"rounded-3 border-0 fs20 fw500 btnres"}
                    textColor={footerData?.scheduler?.CTA?.textColor}
                    background={footerData?.scheduler?.CTA?.backgroundColor}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row footer">
          <div className="container px-0">
            <div className="container d-flex flex-column justify-content-center px-0 p-md-0 p-5 contwidth">
              <div className="row px-0 gy-4 gy-lg-0 ">
                <div className="col-lg-5 col-md-4 h-100">
                  <div className="d-flex flex-column justify-content-between h-100 ">
                    {/* <span className="text-white fs-3">{footerData?.footerText}</span> */}
                    <Link className="navbar-brand text-white fs-2" to={"/"}>
                      <img
                        src={`${baseUrl}${footerData?.footer_logo?.url}`}
                        alt="Footer logo"
                        style={{ width: "171px", height: "26px" }}
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 col-md-8 h-100">
                  <div className="row w-100 gx-4 gy-5 gy-md-0">
                    {footerData?.footer_links?.map((data, idx) => (
                      <div key={idx} className="col-md-3 col-6 bg-success">
                        <div className="d-flex flex-column gap-3 bg-info">
                          {data?.heading && (
                            <span
                              className="fw-bold"
                              style={{ color: " #A1A9B6" }}
                            >
                              {data?.heading}
                            </span>
                          )}
                          {data?.links.map((info, id) => (
                            <Link
                              key={id}
                              to={`${info?.link}`}
                              className=" text-decoration-none text-white"
                            >
                              {info?.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* <div className="col-lg-3">
            <div className="d-flex align-items-center gap-5 justify-content-lg-end justify-content-center px-4">
              {footerData?.social_icons?.map((data, idx) => (
                <div key={idx} className="cursor-pointer">
                  <div dangerouslySetInnerHTML={{ __html: data?.icon }} />
                </div>
              ))}
            </div>
          </div> */}
                <div className="col-12 text-center text-md-start">
                  <p
                    className="text-white"
                    style={{
                      fontWeight: "400",
                      fontSize: _1700 ? "14px" : "18px",
                      lineHeight: "100%",
                      margin: "2rem 0rem",
                    }}
                  >
                    {footerData?.footer_notice}
                  </p>
                  <span className="text-white">{footerData?.copyright}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
